<svg xmlns="http://www.w3.org/2000/svg" class="highlightHover" width="30" height="30" viewbox="-30 -30 160 160"><g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"><path d="m5 5 90 90M95 5 5 95"/></g></svg>
<style>
    .highlightHover:hover {
        background-color: #fcb900;
    }
</style>